<script>
import Layout from "@layouts/auth";
import api from "@services/api";

export default {
  page: {
    title: "Esqueceu sua senha",
    meta: [
      {
        name: "description",
        content: `Forget password`
      }
    ]
  },
  components: {
    Layout
  },
  data() {
    return {
      item: {
        email: ""
      },
      hasProcess: false
    };
  },
  created() {
    this.$store.dispatch("alert/clear");
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    }
  },
  methods: {
    save() {
      api.post(`api/Login/EsqueceuSenha`, this.item).then(response => {
        if (response.data["status"].toLowerCase() == "success") {
          this.hasProcess = true;
        } else {
          throw response;
        }
      });
    },
    logout() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Logout`
        }
      );
    },
    back() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/`
        }
      );
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4" v-show="hasProcess">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span
                  ><img
                    src="@assets/images/logo-dark.png"
                    class="logo  m-auto"
                    alt=""
                    height="50"
                /></span>
              </a>
              <p class="text-muted mb-3 mt-3">
                Os passos para recuperação de senha foram enviados para o e-mail
                solicitado.
              </p>
            </div>
            <b-button variant="primary" class="btn-block" @click="logout()"
              >Voltar</b-button
            >
          </div>
          <div class="card-body p-4" v-show="!hasProcess">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span
                  ><img
                    src="@assets/images/logo-dark.png"
                    class="logo  m-auto"
                    alt=""
                    height="50"
                /></span>
              </a>
              <p class="text-muted mb-3 mt-3">
                Esqueceu sua <strong>senha</strong> de acesso? Informe seu
                e-mail que enviaremos os passos para você cadastrar uma nova
                <strong>senha</strong>
              </p>
            </div>

            <b-form @submit.prevent="save">
              <b-form-group id="email-group" label="E-mail" label-for="email">
                <b-form-input
                  id="email"
                  v-model="item.email"
                  required
                ></b-form-input>
              </b-form-group>

              <b-alert
                variant="danger"
                dismissible
                :show="alert.show"
                @dismissed="closeAlert"
              >
                {{ alert.message }}
              </b-alert>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Enviar</b-button
                >
              </b-form-group>
            </b-form>
          </div>

          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
